import {
  CURRENCY_MODEL_CLASS_NAME,
  CURRENCY_MODEL_KEY_POINTER
} from 'models/daos/currency/constants'

const CURRENCIES_DOMAIN = 'currencies'
const CURRENCIES_DEFAULT_CURRENCY = 'USD'
const CURRENCIES_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {
    [CURRENCIES_DEFAULT_CURRENCY]: {
      data: {
        className: CURRENCY_MODEL_CLASS_NAME,
        name: CURRENCIES_DEFAULT_CURRENCY,
        value: 1
      }
    }
  },
  selected: CURRENCIES_DEFAULT_CURRENCY
}

const CURRENCIES_DOMAIN_MAP_KEY = CURRENCY_MODEL_KEY_POINTER
const CURRENCIES_PATH = {
  ALL: `${CURRENCIES_DOMAIN}.all`,
  ALL_DATA: `${CURRENCIES_DOMAIN}.all.data`,
  DATA: `${CURRENCIES_DOMAIN}.data`,
  SELECTED: `${CURRENCIES_DOMAIN}.selected`
}

// const CURRENCIES_OPEN_EXCHANGE_APP_ID = 'd63ae0654cce4b09b088b85a2031a0e1'
// TODO fix
const CURRENCIES_FIXER_IO_ACCESS_KEY = '51890f2748f0f97117470634a8fd59aa'
const CURRENCIES_ENDPOINT = {
  GET_RATES: NODE_ENV === 'production'
    ? `http://data.fixer.io/api/latest?access_key=${CURRENCIES_FIXER_IO_ACCESS_KEY}`
    // ? `https://openexchangerates.org/api/latest.json?app_id=${CURRENCIES_OPEN_EXCHANGE_APP_ID}`
    : `http://data.fixer.io/api/latest?access_key=${CURRENCIES_FIXER_IO_ACCESS_KEY}`
}

export {
  CURRENCIES_DOMAIN,
  CURRENCIES_DOMAIN_MAP_KEY,
  CURRENCIES_STATE,
  CURRENCIES_PATH,
  CURRENCIES_ENDPOINT,
  CURRENCIES_DEFAULT_CURRENCY
}
